module.exports = __webpack_public_path__ + "static/tractor-e7248b1ab2b271b340f74e43fbbf757f.jpg";